import { Component, Input } from '@angular/core';

import { ModalService } from '../../../services/modal.service';
import { Observable } from 'rxjs';
import { PieChartSize } from '../../../constants';

@Component({
  selector: 'app-pie-chart-modal',
  templateUrl: './pie-chart-modal.component.html',
  styleUrl: './pie-chart-modal.component.scss',
})
export class PieChartModalComponent<T> {
  @Input() header: string = '';
  @Input() subHeader: string = '';
  @Input() labelKey: string;
  @Input() valueKey: string;
  @Input() valueFormattedKey: string;
  @Input() tooltipKey: string;
  @Input() showLegend = true;
  @Input() pieChartSize = PieChartSize.extraLarge;
  @Input() data: Observable<T[]> | T[];

  constructor(private modalService: ModalService) {}

  onClose() {
    this.modalService.dismiss();
  }
}
